import type { I18nTranslation } from '@crehana/i18n';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export { default as LocaleEn } from './localeEn';
export { default as LocaleEs } from './localeEs';
export { default as LocalePt } from './localePt';

const locales: I18nTranslation = { es, pt, en };

export default locales;
